module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/papers-icon-7edc9c9108c00cc83dc8e7865f67cd50.png";